import { combineReducers } from 'redux';
import { EditClient } from './editClient';
import { SendDocuments } from './sendDocuments';

export const settings = combineReducers({
    EditClient,
    SendDocuments,
})